export default "__VITE_ASSET__BAG0EMVc__"